import { createEntityComboBox } from './helpers/createEntityComboBox';
import {
  formatCustomerAddress,
  useCustomerLocationPairQuery,
} from './SelectCustomerLocationPairTouch';

export const SelectCustomerLocationPair = createEntityComboBox.remotelySearched(
  'SelectCustomerLocationPair',
  useCustomerLocationPairQuery,
  {
    formatLabel: (entity) =>
      (entity.account?.name ?? 'Unknown') +
      (entity.name ? ' — ' + entity.name : ''),
    formatSubLabel: (entity) => formatCustomerAddress(entity),
  },
);
